module.exports = __webpack_public_path__ + "media/images/logo-a4c7948722d362ff6018ad990e1a38fd.png";